// extracted by mini-css-extract-plugin
export default {"page":"IndustrialSolutions_page__H8fSz"};